import { render } from "./PaginationItemsPerPage.vue?vue&type=template&id=38302b2a&scoped=true&ts=true"
import script from "./PaginationItemsPerPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationItemsPerPage.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationItemsPerPage.vue?vue&type=style&index=0&id=38302b2a&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38302b2a"],['__file',"resources/js/components/ui/pagination/PaginationItemsPerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38302b2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38302b2a', __exports__)) {
    console.log('reload')
    api.reload('38302b2a', __exports__)
  }
  
  module.hot.accept("./PaginationItemsPerPage.vue?vue&type=template&id=38302b2a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('38302b2a', render)
  })

}


export default __exports__